import ColorSimpleForm from './ColorSimpleForm'

export default ColorSimpleForm
